import { render } from "./TopModelReviews.vue?vue&type=template&id=70d86ce6"
import script from "./TopModelReviews.vue?vue&type=script&lang=js"
export * from "./TopModelReviews.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__